import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { AgEditorToolbarModule, ButtonWithIndicatorModule, ModalWindowModule } from 'ag-common-svc/lib/components';
import { DxValidatorModule } from 'devextreme-angular';
import { SignedPoliciesComponent } from './signed-policies.component';
import { UserAgreementsGridComponent } from './user-agreements-grid/user-agreements-grid.component';
import { LastSignedUserAgreementsPipe } from './last-signed-user-agreements.pipe';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ModalWindowModule,
    ButtonWithIndicatorModule,
    DxValidatorModule,
    AgEditorToolbarModule,
  ],
  declarations: [SignedPoliciesComponent, UserAgreementsGridComponent, LastSignedUserAgreementsPipe],
  exports: [SignedPoliciesComponent, UserAgreementsGridComponent, LastSignedUserAgreementsPipe],
})
export class SignedPoliciesModule {}
